import styled from 'styled-components';
import { Text, crTheme, Link } from '@comicrelief/component-library';
import { useEffect } from 'react';
import { logger } from '@/services/logger/logger';
import { DirectPaymentErrorType } from '@/types/shared-types';
import { ErrorDetails } from './ErrorDetails';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`;

const ErrorTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${crTheme.color('coral_light')};
  border-radius: 2rem;
  padding: 2rem;
  text-align: center;
`;

const isNonProduction = import.meta.env.VITE_CLIENT === 'test';

interface GeneralErrorProps {
  errorType?: DirectPaymentErrorType;
}

function GeneralError({ errorType }: GeneralErrorProps = {}) {
  useEffect(() => {
    if (isNonProduction) {
      console.error('General error page accessed');
    }
    logger.error('General error page accessed');
  }, []);

  return (
    <ErrorContainer>
      <ErrorTextWrapper>
        <Text tag="p" family="Montserrat" size="s" color="black" weight="bold">Something went wrong!</Text>

        <Text tag="p" family="Montserrat" size="s" color="black">We&apos;re having trouble taking your payment right now.</Text>

        <Text tag="p" family="Montserrat" size="s" color="black">Try refreshing the page, or contact us if the problem continues.</Text>

        {isNonProduction && <ErrorDetails errorType={errorType} />}
      </ErrorTextWrapper>

      <Link
        href="/"
        type="button"
        fullWidth
      >
        Return home
      </Link>

      <Link href="https://www.comicrelief.com/contact-us/" target="_blank" rel="noopener noreferrer">Contact us</Link>
    </ErrorContainer>
  );
}

export default GeneralError;
